@if (isOpen()) {
  <div
    class="
      fixed inset-0 bg-black/80 backdrop-blur-[1px] 
      z-50 flex items-center justify-center p-4 animate-fade-in
      md:px-0
      max-h-[calc(100vh)]!
    "
    (click)="onBackdropClick($event)"
  >
    <div class="w-full h-full flex flex-col">
      <!-- options -->
      <div class="w-full flex items-start justify-between p-4">
        <span class="text-white">
          {{ imageIndex + 1 }} / {{ images().length }}
        </span>
        <div class="flex gap-4">
          <button
            type="button"
            class="text-white hover:text-secondary transition-colors"
            (click)="onFullscreen()"
            aria-label="fullscreen"
          >
            <span class="material-symbols-outlined text-2xl">
              {{ isFullscreen() ? 'fullscreen_exit' : 'fullscreen' }}
            </span>
          </button>
          <button
            type="button"
            class="text-white hover:text-secondary transition-colors"
            (click)="onClose()"
            aria-label="Cerrar"
          >
            <span class="material-symbols-outlined text-2xl">close</span>
          </button>
        </div>
        
      </div>
      <div class="w-full px-0 md:px-10 flex justify-between mx-auto">
        <button
          type="button"
          class="text-white hover:text-secondary transition-colors cursor-pointer mx-2 md:mx-10 disabled:opacity-70 disabled:text-gray-500"
          (click)="onPrevious()"
          [disabled]="imageIndex === 0"
        >
          <span class="material-symbols-outlined text-3xl!">chevron_left</span>
        </button>
        <div class="relative w-full h-[80vh] mx-0 md:mx-10 flex justify-center items-center overflow-hidden">
          @if(leaving()){
            <!-- spinner -->
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-secondary"></div>
          }
          @for (img of images(); track img; let i = $index) {
            @if (i === imageIndex) {
              <img
                async
                [src]="img"
                alt="Image"
                class="absolute inset-0 w-full h-full object-contain"
                [class.enter-next]="direction === 'next'"
                [class.enter-prev]="direction === 'prev'"
                [class.leave-next]="leaving() && direction === 'next'"
                [class.leave-prev]="leaving() && direction === 'prev'"
              />
            }
          }
        </div>
        <button
          type="button"
          class="text-white hover:text-secondary transition-colors cursor-pointer mx-2 md:mx-10 disabled:opacity-70 disabled:text-gray-500"
          (click)="onNext()"
          [disabled]="imageIndex === images().length - 1"
        >
          <span class="material-symbols-outlined text-3xl!">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
}